<template>
  <div :class="'matrix-board-panel text-white '+ getOverlayCss()" ref="videoPanel">
    <p v-if="isVideoError" class="overlay-content">錄影主機斷線</p>
    <p v-if="hlsVideoTimeOut" class="overlay-content hls-overlay-content ">連線逾時
       <!-- <button  class="btn btn-outline-light btn-sm" @click="reConnectHls"> 重新連接 </button> -->
      </p>
    
    <div class="matrix-board-panel-title" v-if="panelData && panelData.publicPlaceName">
      <div class="matrix-board-panel-title-content" :title="panelData && panelData.publicPlaceName + ' ' + panelData.id" style="z-index: 1000;">
        {{ panelData && panelData.publicPlaceName }}
      </div>
    </div>
    <div class="matrix-board-panel-zoom text-center py-2 " v-if="panelData && panelData.publicPlaceName" @click="$emit('zoom-click', panelData)">
      <img class="matrix-board-panel-zoom-img" src="../assets/img/zoom.png" alt="" >
    </div>
    <div :style="[imgStyle]" ref="mediaPanel">
      <!-- <img v-if="!isIOSDevice" id="mojImg" ref="mojImg" class="w-100 h-100" style="object-fit: contain;"> -->
      <video v-if="isMobileDevice"  id="Hls" ref="Hls" autoplay playsinline muted type='video/mp4' class="w-100 h-100" style="object-fit: contain;"></video>
      <component v-else  class="w-100 h-100" :is="player" ref="player" @error="onError" @timeout="onTimeout" @end="onEnd"></component>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { FlvPlayer, MjpegPlayer, JpegPlayer } from '@isurveillance/vue2-components'
import CONST from '../utils/const'
import Utils from '../utils/utils'
import {getRelayMapping} from '../utils/utils'
import Hls from 'hls.js';



export default {
  props: ['panelData','isZoom'],
  data(){
    return {
      imgStyle: {},
      imgWidth: 0,
      imgHeight: 0,
      player: '',
      isVideoError: false,
      timeoutCount: 0,
      isSaxian: false,
      isHlsSupport: Hls.isSupported(),
      canPlayType:"",
      isMediaVisible: false,
      hlsVideoTimeOut: false,


    }
  },
  computed: {
    ...mapState("mobileDetect", { isIOSDevice: "isIOSDevice" }),
    ...mapState("mobileDetect", { isMobileDevice: "isMobileDevice" }),

  },
  methods:{
    getOverlayCss(activity) {
      let css= ""
      if(this.isVideoError) {
        css = 'p-0 overlay'
      }
      if(this.hlsVideoTimeOut) {
        css = 'p-0 hls-overlay'
      }

      return css
    },


    setPlayer() {
      let result = false
      if(this.panelData.id) {
        result = CONST.MJPEG_DEVICE_ID.includes(this.panelData.id)
      }
      const a = Utils.getCctvPlayerType(this.panelData);

      this.player=a;
      setTimeout(() => {
        this.play();
      }, 1000)

    },
    setImgSize() {
      const panelWidth = this.$refs.videoPanel.clientWidth
      const panelHeight = this.$refs.videoPanel.clientHeight
      
      this.imgWidth = panelWidth
      this.imgHeight = panelHeight
      this.imgStyle = { width: `${this.imgWidth}px`, height: `${this.imgHeight}px`}
    },
    async play(){
        const streamUrl = await this.getPlayUrl();
        if (this.panelData && this.panelData.streamUrl && !Utils.isEmptyObject(this.$refs.player)) {
          this.$refs.player.setup(streamUrl, true);
        } 
    },

    async getPlayUrl() {
      let playUrl = ''
      if(CONST.MJPEG_DEVICE_ID.includes(this.panelData.id) ) {
        playUrl = this.panelData[CONST.TRAFFIC_CCTV_KEY.URL]

      }else if ((this.isMobileDevice)){
        console.log("this.isMobileDevice")
  
        // const urlSplit = this.panelData[CONST.TRAFFIC_CCTV_KEY.URL].split('/') //['ws:', '', '10.179.20.35:8089', 'NVR', 'cv99001']

        // playUrl = `https://${window.location.host}/mjpeg/StreamDecode/GetStream?rtspUrl=rtsp://${urlSplit[2].split(':')[0]}/${urlSplit[4]}/live.m3u8`
        // playUrl = `https://${window.location.host}/cv02003/index.m3u8`
        // playUrl = `https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8`
          
        
        playUrl = await getRelayMapping(this.panelData);
        const httpUrl = (playUrl).replace("wss://", "https://");
        const videoHls = this.$refs.Hls;
        const hlsUrl = httpUrl+"/live.m3u8";
        
        
        // this.canPlayType = videoHls.canPlayType('application/vnd.apple.mpegurl');
        if (Hls.isSupported()){
        // if (this.canPlayType === 'probably' || this.canPlayType === 'maybe'){
            videoHls.src =  hlsUrl ;
            this.hlsCheckError(videoHls);
         
          }else{
            var hls = new Hls();
            hls.loadSource(hlsUrl);
            hls.attachMedia(videoHls);
            this.hlsCheckError(hls);
          }
        }
        else {
          playUrl = await getRelayMapping(this.panelData)
        }

        // console.log('playUrl', playUrl)
        return playUrl

        
    },

    stop(){
      this.$refs.player.stop()
    },

    // stopHls(){
    //   this.$refs.Hls.stop();
    // },

    onError(event) {
      //其他不管是連線錯誤或是播放器錯誤
      console.log('onError', this.panelData.name)
      // this.isVideoError = true    //重連影像: 先 stop => setup => play
      // this.reConnectVideo()
    },
    onTimeout(event) { 
      //30秒內沒有播放新的 frame 就會 timeout
      console.log('onTimeout', this.panelData.name, 'count', this.timeoutCount)


      //兩次Timeout才顯示斷線，不然先重連
      // this.timeoutCount++
      // if(this.timeoutCount < 2) { 
      //   this.reConnectVideo()
      // } else {
      //   this.timeoutCount = 0
      //   this.isVideoError = true
      // }

      // 審查先全部重連
      this.reConnectVideo()
      
    },
    onEnd(event) {
      console.log('onEnd', this.panelData.name)
    }, 


    hlsCheckError(videoHls) {

      const handleHlsError = (error) => {
        if (error.code === 2 || error.fatal === true || error.code === 4) {
          console.log("handleHlsError",error);
          
            // 錯誤代碼 2 代表網路錯誤；錯誤代碼 4 代表解碼錯誤
            //https://developer.mozilla.org/en-US/docs/Web/API/MediaError/code
            this.hlsVideoTimeOut = true; // 標記 HLS 播放已逾時

            //斷線後，每30秒重新連線，連續三次無法連線則return
            this.timeoutCount++;
            if(this.timeoutCount >2){
              this.timeoutCount=0;
              return ;
            }
            //設定 30 秒後再重試連線
            setTimeout(() => {
                    console.log("ReconnectHls");
                    // this.reConnectVideo();
                    if(!Utils.isEmptyObject(this.panelData))
                    this.setPlayer();
                }, 30000);
              
        } else {
          // console.log("no ERROR");
            this.hlsVideoTimeOut = false; 
        }
    };

    if (Hls.isSupported()) {
    // if (this.canPlayType === 'probably' || this.canPlayType === 'maybe'){
        // 原生 HLS 支援的情況
        videoHls.addEventListener('error', (event) => {
          handleHlsError(videoHls.error);
          console.log("videoHls.error",videoHls.error);

        });
      } else {
        // 不支援原生 HLS，使用 hls.js plugin
        videoHls.on(Hls.Events.ERROR, (event, data) => {
            // console.log('Hls.Events.ERROR', event, data);
            handleHlsError(data);
        });
      };
    },

    reConnectVideo() {

      if (this.$refs.player && this.$refs.player.stop) {
        this.$refs.player.stop();
      }

      setTimeout(() => {
        console.log("10 seconds later reConnectVideo");

        if (!Utils.isEmptyObject(this.panelData)) {
          this.setPlayer();
        }
      }, 3000);
    },


    // reConnectVideo() {
    //   this.$refs.stop();
    //   if(!Utils.isEmptyObject(this.panelData))
    //     this.setPlayer();
      
    // },

    // reConnectHls() {
    //   this.stopHls();
    //   if(!Utils.isEmptyObject(this.panelData))
    //     this.setPlayer();

    //   console.log("reConnectHls");
    // },

    observerLoading(){
      //lazy loading
      console.log('observerLoading');
      const options = {
        root:null,
        rootMargin: '0px',
        threshold: 0.5
      };

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            // console.log('entry', entry);
            this.isMediaVisible = true;
          }
        })
      }, options);
      observer.observe(this.$refs.mediaPanel);
      // console.log("this.$refs.mediaPanel",this.$refs.mediaPanel);
    }

  },
  watch:{
    isMediaVisible(){
      //detect if panel is attached
      if(this.isMediaVisible) {
          setTimeout(() => {
            this.play();
        }, 1000)
      }
    }, 
    
  },
  
  mounted() {
    this.setImgSize();
    if(this.isMobileDevice){
      this.observerLoading();
    }else{
      
      if(!Utils.isEmptyObject(this.panelData))
        this.setPlayer()
    }
  },
  beforeDestroy() {
    this.stop();
    if (this.hls) {
       this.hls.destroy();
     }
  },
  components: { FlvPlayer, MjpegPlayer, JpegPlayer }
}
</script>

<style scoped>
p {
  color: #fff;
  font-size: calc(2vmin);
}

.overlay-content {
  padding: 2rem;
}

.hls-overlay-content{
  font-size: calc(5vmin);
}
.matrix-board-panel-zoom{
  opacity: 0.4 !important;
}

.mobile-panel-zoom{
  height: 530px ;
}

</style>
